import { Component } from '@angular/core';
import { Accord } from 'src/app/modules/shared/models/accord';
import { GlobalStoreService } from '../../services/global-store.service';

@Component({
  selector: 'app-reports',
  standalone: false,
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent {

  constructor(public globalStore: GlobalStoreService) { }
  filtersAccord: Accord = {
    id: 1,
    name: 'Filters',
    active: true
  };

  onAccordTitleClick(accord: Accord): void {
    accord.active = !accord.active;
  }

  getAccordIcon(accord: Accord): string {
    return accord.active ? 'fa-chevron-down' : 'fa-chevron-right';
  }

  get getAccordVisibility() {
    return this.globalStore.selectedReport === 13 || this.globalStore.selectedReport === 10 ? true : false;
}

}
